import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DwRoutingMessageService, DwUserService} from '@webdpt/framework';
import {DwModalService} from 'ng-quicksilver';
import {TranslateService} from '@ngx-translate/core';
import {Observable, of} from 'rxjs';
import {FxDapHttpClient} from '../../fx-http-client';

@Component({
  selector: 'fx-tool-bar',
  templateUrl: './fx-tool-bar.component.html',
  styleUrls: ['./fx-tool-bar.component.less']
})
export class FxToolBarComponent implements OnInit {
  @Input() programId: string = '';
  @Input() btnData: any[] = []; //按钮资料\
  btnList$: Observable<Array<{
    icon: string,
    type: string,
    id: string,
    name: string,
    disabled: () => boolean
  }>>;
  @Output() onButton = new EventEmitter<boolean>();
  @ViewChild('btn') btnW: ElementRef; //绑定按钮栏位的节点
  @ViewChild('btns') btns: ElementRef;
  public currentStyles = {}; //浮层按钮的样式
  public showBtn = false; //更多按钮显示层
  public btnMore: any[] = []; // 更多按钮
  public showMoreBtn = false;


  constructor(
    public http: FxDapHttpClient,
    private translateService: TranslateService,
  ) {
  }

  ngOnInit() {
    this.btnList$ = this.updateButtonList();
  }

  ngAfterViewInit() {
    // this.reizesWidth();
  }

  updateButtonList(): Observable<any> {
    return Observable.create(observer => {
      this.getAuthedButtonList(this.programId).then(lstBtn => {
        const result = this.btnData.map(item => {
          const index = lstBtn.findIndex(btn => btn.id === item.id);
          return index < 0
            ? item
            : Object.assign({}, item, {
              authed: true,
              icon: lstBtn[index].icon,
              name: lstBtn[index].name
            });
        });
        observer.next(result.filter(item => item.authed));
        observer.complete();
      });
    });
  }

  async getAuthedButtonList(programId: string): Promise<any> {
    try {
      const response = await this.http.post('A/IACommonService/showButtonDisplay', {param: {program_no: programId}}).toPromise();
      if (response.success && response.data) {
        // return response.data.map(item => {
        //   return {id: item.abe003, name: item.abe003_n1};
        // });
        return response.data.map(item => {
          return item.icon
            ? Object.assign({}, item, {icon: 'anticon ' + item.icon})
            : item;
        });
      } else {
        return [];
      }
    } catch (e) {
      return [];
    }
  }

  //宽度适应
  reizesWidth() {
    let sum = 0;
    let allW = this.btnW.nativeElement.clientWidth;
    let btnChild = this.btnW.nativeElement.children;
    //console.log(btnChild)
    //console.log(this.btnData)

    let btnsWidth = [];
    for (let i = 0; i < btnChild.length; i++) {
      let w = btnChild[i].clientWidth + 6;
      sum += w;
      btnsWidth.push(w);
    }
    sum += 50;
    if (sum > allW && allW != 0) {
      for (let index = this.btnData.length - 1; index >= 0; index--) {
        //console.log(index, this.btnData[index],'index')
        this.btnMore.splice(0, 0, this.btnData[index]);
        this.btnData.splice(index, 1);
        sum -= btnsWidth[index];
        if (sum < allW) {
          break;
        }
      }
      setTimeout(() => {
        this.showMoreBtn = true;
      }, 0);
    }

    //console.log(this.btnData)
    //console.log(this.btnMore)
  }

  //对应的按钮操作
  clickFixedBtn(name: any): void {
    this.onButton.emit(name);
  }

  public checkActionDataAurhority(action: string, data: any, table?: string): Observable<boolean> {
    const postParam = {
      action_list: [action],
      primaryKey_value_map: data,
      program_no: this.programId,
      table_no: table || '',
    };
    return Observable.create(observer => {
      this.http.post('A/IACommonService/chkActionDataAuthority', {param: postParam}).subscribe(
        response => {
          // if (response.success && response.data && response.data.find(item => item === action)) {
          observer.next(response.success && response.data && response.data.find(item => item === action));
          // } else
        },
        error => {
          observer.next(false);
        },
        () => {
          observer.complete();
        }
      );
    });
  }
}
